import { supabase } from '../lib/supabase';

const FIELDS = 'id, owner_id, full_name, email, phone, company, job_title, created_at, updated_at';

const clean = (v) => {
  const t = (v ?? '').trim();
  return t === '' ? null : t;
};

const toPayload = (values) => ({
  full_name: (values.full_name ?? '').trim(),
  email: clean(values.email),
  phone: clean(values.phone),
  company: clean(values.company),
  job_title: clean(values.job_title)
});

export const contactService = {
  async getContacts() {
    const { data, error } = await supabase
      .from('contacts')
      .select(FIELDS)
      .order('created_at', { ascending: false });
    if (error) throw error;
    return data || [];
  },

  async createContact(ownerId, values) {
    const { data, error } = await supabase
      .from('contacts')
      .insert({ owner_id: ownerId, ...toPayload(values) })
      .select(FIELDS)
      .single();
    if (error) throw error;
    return data;
  },

  async updateContact(id, values) {
    const { data, error } = await supabase
      .from('contacts')
      .update(toPayload(values))
      .eq('id', id)
      .select(FIELDS)
      .single();
    if (error) throw error;
    return data;
  },

  async deleteContact(id) {
    const { error } = await supabase.from('contacts').delete().eq('id', id);
    if (error) throw error;
  },

  // Connection status is derived: a Contact with at least one linked Moment.
  // Returns Map(contactId -> { count, last }).
  async getMomentStats() {
    const { data, error } = await supabase
      .from('moment_contacts')
      .select('contact_id, moments(occurred_at)');
    if (error) throw error;
    const stats = new Map();
    (data || []).forEach((row) => {
      if (!row.moments) return;
      const at = row.moments.occurred_at;
      const cur = stats.get(row.contact_id) || { count: 0, last: null };
      cur.count += 1;
      if (!cur.last || new Date(at) > new Date(cur.last)) cur.last = at;
      stats.set(row.contact_id, cur);
    });
    return stats;
  },

  // Contacts that originated from a card submission.
  async getCardContactIds() {
    const { data, error } = await supabase
      .from('card_leads')
      .select('contact_id')
      .not('contact_id', 'is', null);
    if (error) throw error;
    return new Set((data || []).map((r) => r.contact_id));
  },

  async mergeContacts(keepId, removeId) {
    const { error } = await supabase.rpc('merge_contacts', { p_keep: keepId, p_remove: removeId });
    if (error) throw error;
  }
};